import { render } from "./BaseDataMaterialSinglesps.vue?vue&type=template&id=95d59852"
import script from "./BaseDataMaterialSinglesps.vue?vue&type=script&lang=js"
export * from "./BaseDataMaterialSinglesps.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__